import React, { memo } from 'react';
import { Card } from 'react-bootstrap';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect, useDispatch } from 'react-redux';


import * as _ from 'lodash';

import styled from 'styled-components';
import { stockNewsRequest } from 'components/modal/stockDetail/actions';
import { makeGetStockNews } from 'lib/selector';
import { stockNewsRequestSuccess } from 'components/modal/stockDetail/actions';

//#region styled
const StyledDivTable = styled.div`
  position: relative;

  table {
    position: relative;
  }

  table thead th {
    position: sticky;
    top: 0;
  }

  table.theme-light thead th {
    background: #666666;
  }
  table.theme-light thead th.highlight {
    background: #494757;
  }

  table.theme-light.table-analysis tbody tr:nth-child(odd) td {
    background: #eeeeee;
  }
`;

const StyleBtn = styled.button`
  padding: 5px 20px;
  border-radius: 3px;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;

  &:hover,
  &:focus,
  &:active {
    outline: none;
    color: #f0b90b;
    border-color: #f0b90b;
    background: #878379;
  }
`;

const StyleBtnSubmit = styled(StyleBtn)`
  color: #27272d;
  border: 1px solid #f0b90b;
  background: #f0b90b;
`;

const StyleLink = styled.a`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: var(--half_white);

  &:hover{
    color: #f0b90b;
  }
`;

//#endregion

function PanelNews(props) {
  const { symbol, stockNews, t, theme } = props;
  const dispatch = useDispatch();

  React.useEffect(() => {
    return () => {
      dispatch(stockNewsRequestSuccess(null));
    };
  }, []);

  React.useEffect(() => {
    dispatch(stockNewsRequest(symbol));
  }, [symbol]);

  function formatDate(params) {
    let strDate = '';
    const _arrDate = params.split('T');
    const _arrTime = _arrDate[1].split(':');
    strDate += _arrTime[0] + ':' + _arrTime[1];
    strDate += ' ' + _arrDate[0].split('-').reverse().join('/');

    return _arrDate[0].split('-').reverse().join('/');
  }

  return (
    <Card
      className="mt-2 w-100"
      style={{ height: 'calc(100vh - 185px)', background: '#020210' }}
    >
      <Card.Body className="p-0">
        <PerfectScrollbar style={{ height: 'calc(100% - 5px)' }}>
          <StyledDivTable>
            <table className={'table table-borderless table-analysis theme-' + theme}>
              <thead>
                <tr>
                  <th className="text-left">{t('algo.ptcp.txt-Time')}</th>
                  <th className="text-left">{t('algo.ptcp.txt-Title')}</th>
                  <th className="text-right">{t('algo.ptcp.txt-Source')}</th>
                </tr>
              </thead>
              <tbody>
                {stockNews &&
                  !!stockNews.length &&
                  stockNews.map((item, index) => (
                    <tr key={index}>
                      <td className="txt-content">
                        {formatDate(item.PublishTime)}
                      </td>
                      <td className="txt-content">
                        <div className="d-grid">
                          <StyleLink
                            href={item.URL}
                            target="_blank"
                            rel="noreferrer noreferrer"
                          >
                            {item.Title}
                          </StyleLink>
                        </div>
                      </td>

                      <td className="txt-content text-right">
                        <StyleBtnSubmit>{item.Source}</StyleBtnSubmit>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </StyledDivTable>
        </PerfectScrollbar>
      </Card.Body>
    </Card>
  );
}

const makeMapStateToProps = () => {
  const getStockNews = makeGetStockNews();

  const mapStateToProps = (state) => {
    return {
      stockNews: getStockNews(state),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(memo(PanelNews));
